import { HttpQueryConfig } from '../../../core/model/HttpQueryConfig.model';

  // todo: handling errors in requests
export const ThroughputMonitoredServiceQuery: HttpQueryConfig = {
  GetThroughputMonitoredServices: {
    key: 'GetThroughputMonitoredServices',
    url: '/api/customers/{customerId}/throughput-monitored-services',
    errors: {},
  },
  GetNetworkServiceBitrates: {
    key: 'GetNetworkServiceBitrates',
    url: '/api/customers/{customerId}/l3-services/{itemId}/network-service-bitrates',
    errors: {},
  },
};
